import React from 'react';

const Privacy: React.FC = () => (
  <div className="max-w-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
    <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
    <p className="text-sm text-gray-500 text-center mb-8">Last Updated: May 15, 2025</p>
    <pre className="whitespace-pre-wrap text-left text-gray-800 bg-white p-4 rounded shadow overflow-x-auto text-sm">
{`
Privacy Policy
Last Updated: May 15, 2025
1. Introduction

WeTrackSSL ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect your personal data when you visit our website or use our SSL certificate monitoring services.
2. Information We Collect

We collect several categories of information:

    Account Information:
        Email address
        Username
        Password (hashed for security)
        Domain names monitored
    Payment Information:
        Processed securely through Stripe
        No credit card numbers stored on our servers
        Subscription status
    Service Usage Data:
        Certificate expiration dates
        Notification preferences
        Monitoring frequency settings

3. How We Collect Information

Information is collected through:

    Direct input when creating an account
    Stripe payment processing system
    Service configuration settings
    System logs for monitoring purposes

4. How We Use Your Information

We use collected information solely for:

    Providing SSL certificate monitoring services
    Sending expiration notifications
    Processing payments through Stripe
    Maintaining service functionality
    Improving service reliability

5. Data Protection

We maintain robust security measures:

    Encryption of sensitive data
    Secure password hashing
    Regular security audits
    Access controls for authorized personnel
    Data backup procedures

6. Third-Party Services

We work with limited third-party services:

    Stripe for secure payment processing
    Email service providers for notifications
    Infrastructure providers for hosting

7. User Rights

You have the right to:

    Request access to your personal data
    Correct inaccurate information
    Delete your account and associated data
    Opt out of non-essential communications
    Request data export

8. Data Retention

We maintain your data for:

    Active accounts: Duration of service usage
    Inactive accounts: 90 days after last activity
    Payment records: As required by law

9. Changes to This Policy

We reserve the right to update this Privacy Policy. When changes occur, we'll notify you through:

    Email notification
    Updates to this webpage
    Service dashboard notifications

10. Contact Us

Questions about this Privacy Policy should be directed to:

    [support@wetrackssl.com]
`}
    </pre>
  </div>
);

export default Privacy;
